module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAAESzkQjAAAAAXNSR0IArs4c6QAAAPpJREFUGBljYEAFOUVND8AiuUVNX1ClwLyZM2eyghhMd+58FMaUzy1q/AsTZYQxCstaTH7/+dfCUF7ewZ9b2PQKJsFQUNJkCeMw/fn3PzKvpCkMJADWC1S6DWhTA0wFQ05h438WEC+nqPEmGwOzHEjkbEFZsyZYSUPDfrAsiMOYW9Ls8v/vv92MjExZk/tqp4NVQAmw6f///2fMLW5ewsjwP4SJkcFnYm/9brBOZJUNDTO53nx8uQcopsbCymjLhCz59tsHIaBuSQbG/+8ZWJg+gI2trGwT/vLz94H/DAxCjMxMdpO7a++CjQUGqCGQsRaIAyf31V1ENgkA6GZTa+Fa2zgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gateway/more_icon.png
// module id = 776
// module chunks = 137